'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $(function () {

        // for link to tab
        var url = window.location.href;
        if (url.match('#')) {
            $('.nav-tabs a[data-target="#' + url.split('#')[1] + '"]').tab('show');
        }

        $('.nav-tabs a', this).click(function () {
            var $this = $(this);
            $this.tab('show');
            var scrollmem = $('body').scrollTop();
            // update hash without write to history
            if (history.replaceState) history.replaceState(undefined, undefined, $(this).attr('data-target'));
            $('#tabAnchorName').val($(this).attr('data-target'));
            $('html, body').scrollTop(scrollmem);
        });
    });
};

var $ = require("jquery");

;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/tabs.js
// module id = 456
// module chunks = 0